import { useEffect, useState, type FC, type ReactNode } from 'react'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../components/form'
import { Input } from '../../components/input'
import { Button } from '../../components/button'

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"



import { LoaderCircle, Pencil, Trash } from 'lucide-react'

import ErrorComponent from '../ErrorComponent'
import axios from 'axios'
import { cn } from '@univdiam/ui/lib/utils'
import { Separator } from '@univdiam/ui/components/separator'


const AddOrderInstructionSchema = z.object({
    label: z.string().min(1, {
        message: "This field is required",
    }).max(100, "Label cannot exceed 100 characters."),
    value: z.string().min(1, {
        message: "This field is required",
    }).max(255, "Value cannot exceed 255 characters.")
})

type AdditionalInstructionsType = {
    label: string;
    value: string;
    id: string;
}

type AddOrderInstructionType = {
    children?: ReactNode,
    onSubmit: (values: z.infer<typeof AddOrderInstructionSchema>) => void,
    isError?: boolean,
    isLoading?: boolean,
    error?: Error | null,
    AdditionalInstructions: AdditionalInstructionsType[];
    handleInstructionAction: (action: string, data: AdditionalInstructionsType) => void,
    existedValues?: z.infer<typeof AddOrderInstructionSchema>,
}

const AddOrderInstruction: FC<AddOrderInstructionType> = ({ onSubmit, isError, isLoading, error, AdditionalInstructions, handleInstructionAction, existedValues }) => {
    const form = useForm<z.infer<typeof AddOrderInstructionSchema>>({
        resolver: zodResolver(AddOrderInstructionSchema),
        defaultValues: {
            label: "",
            value: "",
        },
    })

    useEffect(() => {
        if (existedValues) {
            form.setValue('label', existedValues.label)
            form.setValue('value', existedValues.value)
        }
    }, [existedValues, form])

    const isAxiosError = axios.isAxiosError(error)
    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <FormField
                    control={form.control}
                    name="label"
                    render={({ field }) => (
                        <FormItem className='mb-0 w-full'>
                            <FormLabel className='text-[#38404D]'>Label <span className='text-[#16111]'>*</span></FormLabel>
                            <FormControl className='mt-[6px]'>
                                <Input placeholder="eg: Metal Type" {...field} maxLength={100} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="value"
                    render={({ field }) => (
                        <FormItem className='mt-[16px] mb-0 w-full'>
                            <FormLabel className='text-[#38404D]'>Value <span className='text-[#16111]'>*</span></FormLabel>
                            <FormControl className='mt-[6px]'>
                                <Input placeholder="14kt white rose" {...field} maxLength={255} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <div className='mt-[16px]'>
                    {
                        isError && <ErrorComponent message={isAxiosError ? error?.response?.data?.error : ''} />
                    }
                </div>

                <div className='mt-[32px] flex items-center gap-[16px]'>
                    <Button type="submit" className='w-fit ' isLoading={isLoading}>
    {existedValues ? 'Update Instruction' : 'Add Instruction'}
</Button>
                </div>
                <div>
                    <p className='caption mb-[16px]'>Instructions</p>
                    <div>
                        {AdditionalInstructions.map((instruction) => (
                            <>
                                <div key={instruction.id} className={cn("grid grid-cols-[25%_1fr_auto] gap-4 items-start text-body2 leading-relaxed my-[8px]")} onClick={() => {

                                }}>
                                    <span className="break-all text-gray-600">{instruction.label}</span>
                                    <span className='font-semibold break-all'>{instruction.value}</span>
                                    <span className='flex gap-3 justify-end items-start mt-1'>
                                        <Pencil type='button' size={14} className='cursor-pointer text-gray-500 hover:text-black transition-colors' onClick={() => {
                                            handleInstructionAction('edit', instruction)
                                        }} />
                                        <Trash size={14} className='cursor-pointer text-red-500 hover:text-red-700 transition-colors' onClick={() => {
                                            handleInstructionAction('delete', instruction)
                                        }} />
                                    </span>
                                </div>
                                <Separator />
                            </>
                        ))}
                    </div>
                </div>
            </form>


        </Form>
    )

}

export { AddOrderInstruction, AddOrderInstructionSchema }